import { useMemo } from 'react';

import { useWindowSize } from '@hooks';

function createUseResponsiveValue(breakpoints: number[]) {
  return <T>(values: T[]): T => {
    const [width] = useWindowSize();

    return useMemo(() => {
      for (let breakpointIdx = 0; breakpointIdx < breakpoints.length; breakpointIdx += 1) {
        if (width < breakpoints[breakpointIdx]) {
          for (let i = breakpointIdx; i >= 0; i -= 1) {
            if (values[i] !== undefined) {
              return values[i];
            }
          }
        }
      }

      return values[values.length - 1];
    }, [values, width]);
  };
}

export default createUseResponsiveValue;
